import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

class Tab extends React.PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
    };

    state = {
        index: 1,
    };

    handleClick = index => {
        this.setState(
            {
                index,
            },
            () => {
                this.props.onChange(index);
            },
        );
    };

    render() {
        const { index } = this.state;

        return (
            <div className={styles.tab}>
                <span
                    className={`${styles.loginById} ${index === 0 ? styles.active : ''}`}
                    onClick={this.handleClick.bind(this, 0)}>
                    账号登录
                </span>
                <span
                    className={`${styles.loginByPhone} ${index === 1 ? styles.active : ''}`}
                    onClick={this.handleClick.bind(this, 1)}>
                    手机登录
                </span>
            </div>
        );
    }
}

export default errorBoundary(Tab);
